module.exports = __webpack_public_path__ + "static/p09_pajaroRvolandoAlaL-4ea2085078a0026bf11760a2ba2a2977.png";